import { ref } from 'vue'

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && window.gtag
}

// Track page views
export const trackPageView = (pageTitle, pageLocation) => {
  if (isGtagAvailable()) {
    window.gtag('config', 'G-SPJJ1BMYLJ', {
      page_title: pageTitle,
      page_location: pageLocation
    })
  }
}

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, parameters)
  }
}

// Track user signup/account creation
export const trackSignup = (userData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'sign_up', {
      method: userData.method || 'email', // 'email', 'google', etc.
      user_id: userData.uid,
      email: userData.email,
      company_name: userData.companyName,
      location: userData.location,
      timezone: userData.timezone
    })
  }
}

// Track user login
export const trackLogin = (userData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'login', {
      method: userData.method || 'email',
      user_id: userData.uid,
      email: userData.email
    })
  }
}

// Track onboarding completion
export const trackOnboardingComplete = (userData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'onboarding_complete', {
      subscription: userData.subscription,
      plan: userData.plan
    })
  }
}

// Track demo booking
export const trackDemoBooking = (bookingData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'demo_booking', {
      booking_id: bookingData.bookingId,
      user_id: bookingData.userId,
      date: bookingData.date,
      time: bookingData.time,
      timezone: bookingData.timezone,
      booking_method: bookingData.bookingMethod || 'unknown' // 'zoom_scheduler' or 'calendly'
    })
  }
}

// Track subscription/payment
export const trackSubscription = (subscriptionData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'purchase', {
      transaction_id: subscriptionData.transactionId,
      value: subscriptionData.value,
      currency: subscriptionData.currency || 'USD',
      user_id: subscriptionData.userId,
      plan: subscriptionData.plan
    })
  }
}

// Set user properties
export const setUserProperties = (userData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('config', 'G-SPJJ1BMYLJ', {
      user_id: userData.uid,
      user_email: userData.email,
      company_name: userData.companyName,
      company_location: userData.location,
      subscription_status: userData.subscription,
      plan_type: userData.plan
    })
  }
}

// Main composable
export const useGoogleAnalytics = () => {
  return {
    trackPageView,
    trackEvent,
    trackSignup,
    trackLogin,
    trackOnboardingComplete,
    trackDemoBooking,
    trackSubscription,
    setUserProperties,
    isGtagAvailable
  }
} 